<template>
    <div v-if="!isSingleView" class="popup-global-news">
        <div class="text-center">
            <h1>Alles rund ums Intranet</h1>
            <h3 class="no-margin-top">Wir bringen Sie auf den neuesten Stand</h3>
        </div>
        <div class="margin-bottom-5 text-center">
            <img alt="Farbverlauf" :src="'/img/line_colored.svg'" class="box-top-image"/>
        </div>
        <div class="article-container">
            <div v-for="news in allUnreadNewsSorted" class="article">
                <div>
                    <img v-if="news.preview" :src="'https://daten.mein-intra.net' + getImage(news, false)"
                        :data-large-src="'https://daten.mein-intra.net' + getImage(news)"
                        v-light-box alt="SSN Bild" class="article-image">
                </div>
                <div class="article-content">
                    <h5 class="no-margin-top font-size-13 margin-bottom-6">{{dateText(news.datetime)}}</h5>
                    <h2 class="no-margin-top intranet-headline-color">{{news.title}}</h2>
                    <p class="message-content fr-view font-size-16 text-wrap" v-html="news.content_teaser"></p>
                </div>
                <div class="article-action">
                    <button v-interact="() => setGlobalNews(news.id)" class="button button-primary">Weiter lesen</button>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="message-content fr-view">
        <div v-html="currentGlobalNewsData.content"></div>
    </div>
</template>

<script lang="ts">
    import {SubmitIcons} from '@/library/design';
    import {Popup} from '@/library/popup';
    import {NoOperation} from '@/library/utils';
    import dateHelper from '@/utils/portuna/dateHelper';
    import axios from 'axios';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {dateText} from '@/library/modules/procurement';

    @Component({
        name: 'GlobalNewsListPopup',
        components: {},
        methods: {
            dateText,
            dateHelper,
        },
    })
    export default class GlobalNewsListPopup extends Vue
    {
        @Prop({
            type: Array,
            required: true,
        }) allUnreadNews: IGlobalNewsPopupEntry[];

        currentGlobalNews: number = 0;

        isSingleView: boolean = false;

        get allUnreadNewsSorted()
        {
            return this.allUnreadNews.sort((a, b) =>
            {
                if (a.news_priority > b.news_priority)
                {
                    return -1;
                }
                else if (a.news_priority === b.news_priority)
                {
                    if (a.datetime > b.datetime)
                    {
                        return -1;
                    }
                }

                return 0
            });
        }

        get currentGlobalNewsData()
        {
            return this.allUnreadNews.find(news => news.id === this.currentGlobalNews) as IGlobalNewsPopupEntry;
        }

        get closeButton()
        {
            return {
                type: 'close',
                title: 'Schließen und zukünftig verbergen',
                icon: SubmitIcons.close,
                cmd: (popup: Popup) =>
                {
                    axios
                    .post(
                        '/application/application/mark-global-news-read',
                        {
                            ids: this.isSingleView ? [this.currentGlobalNews] : this.allUnreadNews.map(news => news.id),
                        },
                    )
                    .catch(NoOperation);
                    popup.close();
                },
            };
        }

        created()
        {
            this.emitter.emit('setButtons', [this.closeButton]);
        }

        setGlobalNews(id: number)
        {
            this.isSingleView      = true;
            this.currentGlobalNews = id;

            this.emitter.emit('setButtons', [
                {
                    type: 'primary',
                    title: 'Zurück zur Liste',
                    icon: SubmitIcons.navigate_before,
                    cmd: () =>
                    {
                        this.resetGlobalNews();
                    },
                },
                {
                    type: 'success',
                    title: 'Meldung anzeigen',
                    icon: 'remove_red_eye',
                    cmd: (popup: Popup) =>
                    {
                        this.$router
                        .push({path: '/news/global/view/id/' + id})
                        .then(popup.close)
                        .catch(NoOperation);
                    },
                },
            ]);
        }

        getImage(news: IGlobalNewsPopupEntry, withLarge = true)
        {
            return withLarge ? news.preview.paths.large || news.preview.paths.medium : news.preview.paths.medium || news.preview.paths.preview;
        }

        resetGlobalNews()
        {
            this.isSingleView      = false;
            this.currentGlobalNews = 0;

            this.emitter.emit('setButtons', [this.closeButton]);
        }
    }
</script>
